var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var loginSlice = {
    loginRequest: function (state) {
        return __assign(__assign({}, state), { pending: true });
    },
    loginRequestSuccess: function (state, action) { return (__assign(__assign({}, state), { pending: false, userInfo: action.payload.userInfo, error: null, menus: action.payload.menus, background: action.payload.background, configureSettings: action.payload.configureSettings })); },
    loginRequestFailed: function (state, action) { return (__assign(__assign({}, state), { pending: false, userInfo: undefined, error: action.payload.error, menus: undefined, background: undefined })); },
    updateUserInfoSuccess: function (state, action) { return (__assign(__assign({}, state), { pending: false, userInfo: action.payload.userInfo, error: null, isAuthenticated: true, menus: action.payload.menus, background: action.payload.background })); },
    updateConfigureSettings: function (state, action) {
        if (state.configureSettings) {
            state.configureSettings = __assign(__assign({}, state.configureSettings), action.payload);
        }
        else {
            state.configureSettings = __assign({ themeAppearanceScreenEnabled: false, securityScreenEnabled: false, avatarSelectionEnabled: false, showRemoveDisplayButton: false }, action.payload);
        }
    },
};
